<template>
  <editor :disabled="disabled" v-model="content" :init="init"></editor>
</template>
<style>
.tox .tox-edit-area__iframe {
  background-color: transparent !important;
}
</style>
<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/icons/default/icons";

import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/preview";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/codesample";
import "tinymce/plugins/link";

import uploadApi from "@/api/files";

const init = {
  content_css: false,
  // skin: false,
  plugins:
    "lists image media table wordcount preview textcolor code fullscreen codesample link",
  toolbar:
    "code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs",
  branding: false,
  menubar: true,
  images_upload_handler: (blob, success, failure) => {
    let file = blob.blob();
    let maxSize = 5 * 1024 * 1024; // 5MB

    if (file.size > maxSize) {
      failure('图片大小不能超过 5MB，请重新选择');
      return;
    }
    uploadApi
      .imageUpload(file)
      .then((response) => {
        if (response.data.status.isOK()) {
          success(response.data.data.img_url);
        } else {
          failure(response.data.error.msg);
        }
      })
      .catch((ex) => {
        console.log(ex);
        failure("上传失败");
      });
  },
};

export default {
  name: "VEditor",
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: 400,
    },
    imageType: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const locale =
      localStorage.getItem("locale") == "zhHans"
        ? "zh_CN"
        : localStorage.getItem("locale");
    return {
      init: Object.assign({}, init, {
        height: this.height,
        skin_url:
          "/static/tinymce/skins/ui/" +
          (localStorage.getItem("dark") &&
          localStorage.getItem("dark") != "false"
            ? "oxide-dark"
            : "oxide"),
        language_url: "/static/tinymce/langs/" + locale + ".js",
        language: locale,
      }),
      content: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.content = newValue;
    },
    content(newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted() {
    tinymce.init({});
  },
};
</script>
